import { CARGO_TYPE, CARGO_TYPE_ID, } from '@types';
import { withPlural } from './withPlural';
import {
	isCargoTypeCartonOrSatchel,
	getCargoTypeFromCargoTypeId
} from '@utils';
import { Text } from '@components';
import React from 'react';
export const getCargoFullDescription = (
	// could be typed once APP-9069 is done
	cargos: any[],
	palletKey: 'pallet_qty' | 'pallet_quantity',
	spaceKey: 'qty' | 'pallet_space_quantity' | 'carton_quantity',
	weightKey: 'total_weight' | 'weight' | 'total_weight_kg',
	isCustomItemCargo: boolean,
	cargoTypeId: number,
	truckSize?: string,
	isSuperdock?: boolean,
	hideCapacity?: boolean,
	separator?: JSX.Element
) => {
	const {
		totalPallets,
		totalSpaces,
		totalItems,
		totalCubic,
		totalWeight,
		totalMacshipItems,
	} = cargos.reduce(
		(acc: {
			totalPallets: number;
			totalSpaces: number;
			totalItems: number;
			totalCubic: number;
			totalWeight: number;
			totalMacshipItems: number
		}, c) => {
			if (!isCustomItemCargo || (isSuperdock && c.cargo_type_id !== CARGO_TYPE_ID.CustomItem)) {
				acc.totalPallets += Number(c[palletKey]) || 0;
			}
			acc.totalSpaces += Number(c[spaceKey]) || 0;
			if (isCustomItemCargo || (isSuperdock && c.cargo_type_id === CARGO_TYPE_ID.CustomItem)) {
				acc.totalItems += Number(c[palletKey]) || 0;
			}
			if (c.total_cubic_volume_mts) {
				const value = parseFloat(c.total_cubic_volume_mts.replace('m³', ''));
				acc.totalCubic += isNaN(value) ? 0 : value;
			}
			if (isCargoTypeCartonOrSatchel(getCargoTypeFromCargoTypeId(cargoTypeId ?? 0) as CARGO_TYPE) && c.machship_items?.length) {
				acc.totalMacshipItems += c.machship_items.reduce((prev: number, current: any) => prev + current.quantity, 0);
			}
			acc.totalWeight += Number(c[weightKey]) || 0;

			return acc;
		},
		{
			totalPallets: 0,
			totalSpaces: 0,
			totalItems: 0,
			totalCubic: 0,
			totalWeight: 0,
			totalMacshipItems: 0
		}
	);
	let cargoType = '';
	const isMachShipCargo = isCargoTypeCartonOrSatchel(getCargoTypeFromCargoTypeId(cargoTypeId) as CARGO_TYPE);
	/* Bundle and Skid fall into the same default 'LTL' bucket as Pallets below, but read their row count
	   as a Qty (freeform freight) rather than pallet Spaces - the same way Other already does. */
	const isOtherFamilyCargo = [CARGO_TYPE_ID.Other, CARGO_TYPE_ID.Bundle, CARGO_TYPE_ID.Skid].includes(cargoTypeId);
	switch (cargoTypeId) {
	case CARGO_TYPE_ID.FullTruckload:
		cargoType = 'FTL'
		break;
	case CARGO_TYPE_ID.Loose:
		cargoType = 'FTL | Loose'
		break;
	case CARGO_TYPE_ID.Other:
		cargoType = 'Other'
		break;
	case CARGO_TYPE_ID.Parcels:
		cargoType = ''
		break;
	case -1:
		cargoType = '';
		break
	case CARGO_TYPE_ID.Pallets:
	case CARGO_TYPE_ID.CustomItem:
	default:
		cargoType = 'LTL'
		break;
	}
	const getText = (): string | React.ReactNode => {
		const strings = [];
		cargoType && !hideCapacity && strings.push(cargoType);
		truckSize && strings.push(truckSize);
		totalPallets && strings.push(`${totalPallets} ${withPlural('Pallet', totalPallets)}`);
		if (isMachShipCargo && totalMacshipItems) {
			strings.push(`${totalMacshipItems} x ${withPlural('Parcel', totalSpaces)}`);
		} else if (totalSpaces) {
			if ((!isCustomItemCargo && !isOtherFamilyCargo) || isSuperdock) {
				strings.push(`${totalSpaces} ${withPlural('Space', totalSpaces)}`);
			} else if ((!isCustomItemCargo && isOtherFamilyCargo) || isSuperdock) {
				strings.push(`${totalSpaces} Qty`);
			}
		}

		(isCustomItemCargo || isSuperdock) && totalItems && strings.push(`${totalItems} ${withPlural('Item', totalItems)}`);
		(isCustomItemCargo || isSuperdock) && totalCubic && strings.push(`${totalCubic.toFixed(2)} m³`);
		totalWeight && strings.push(`${totalWeight} kg`);
		if (!separator) {
			return strings.join(' | ');
		}
		return strings.map((str, index) =>
			<React.Fragment key={index}>
				<Text>{str}</Text>
				{index < strings.length - 1 && separator}
			</React.Fragment>
		);
	}
	return getText();
}